import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

import { ColumnSortData, ColumnSortDirection } from './sortable-table.interface';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'th[sortBy]'
})
export class SortableTableHeaderDirective implements AfterViewInit, OnInit {
    @Output() sort = new EventEmitter<ColumnSortData>();
    @Input() sortBy: string;

    constructor(private _elementRef: ElementRef) {}
    private sortDirection: ColumnSortDirection = ColumnSortDirection.None;

    ngAfterViewInit(): void {
        this._elementRef.nativeElement.classList.add('sortable');
    }

    ngOnInit(): void {
        //
    }

    @HostListener('click', ['$event'])
    onClick($event): void {
        this.sortDirection =
            this.sortDirection === ColumnSortDirection.None || this.sortDirection === ColumnSortDirection.Desc
                ? ColumnSortDirection.Asc
                : ColumnSortDirection.Desc;

        const sortData = {
            sortDirection: this.sortDirection,
            sortProperty: this.sortBy
        } as ColumnSortData;

        this.sort.emit(sortData);
        this.updateIcon();
    }

    reset(): void {
        this.sortDirection = ColumnSortDirection.None;
        this.updateIcon();
    }

    updateIcon(): void {
        const el = $(this._elementRef.nativeElement);
        el.children('i').remove();

        switch (this.sortDirection) {
            case ColumnSortDirection.Asc:
                el.append('<i class="fa fa-chevron-up"></i>');
                break;
            case ColumnSortDirection.Desc:
                el.append('<i class="fa fa-chevron-down"></i>');
                break;
            default:
                break;
        }
    }
}
